import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useAuth } from "./AuthContext";

const LanguageContext = createContext(null);

const TRANSLATIONS = {
  hi: {
    // Sidebar
    "Dashboard": "डैशबोर्ड", "Infra Dashboard": "इन्फ्रा डैशबोर्ड", "Infra Clients": "इन्फ्रा ग्राहक",
    "Factory Orders": "फैक्ट्री ऑर्डर", "Factory Dashboard": "फैक्ट्री डैशबोर्ड", "Factory Management": "फैक्ट्री प्रबंधन",
    "My Factory Orders": "मेरे फैक्ट्री ऑर्डर", "Tasks": "कार्य", "Work Reports": "कार्य रिपोर्ट",
    "Teams": "टीमें", "Performance": "प्रदर्शन", "Follow-ups": "फॉलो-अप", "Activities": "गतिविधियाँ",
    "Chat": "चैट", "My Leaves": "मेरी छुट्टियाँ", "My Profile": "मेरी प्रोफ़ाइल", "Sign Out": "लॉग आउट",
    "Leads": "लीड्स", "Contacts": "संपर्क", "Sales Pipeline": "सेल्स पाइपलाइन", "Products": "उत्पाद",
    "Companies": "कंपनियाँ", "Analytics": "विश्लेषण", "Reports": "रिपोर्ट्स", "Email Templates": "ईमेल टेम्पलेट",
    "Staff Management": "स्टाफ प्रबंधन", "Integrations": "इंटीग्रेशन", "Quick Actions": "त्वरित कार्य",
    "NAVIGATION": "नेविगेशन", "HR MODULE": "एचआर मॉड्यूल", "INFRASTRUCTURE": "इन्फ्रास्ट्रक्चर", "FACTORY": "फैक्ट्री",
    "HR Employees": "एचआर कर्मचारी", "HR Attendance": "एचआर उपस्थिति", "HR Leaves": "एचआर छुट्टियाँ",
    "HR Payroll": "एचआर वेतन", "HR Hiring": "एचआर भर्ती", "Leave Calendar": "छुट्टी कैलेंडर",
    "My Dashboard": "मेरा डैशबोर्ड", "My Leads": "मेरी लीड्स",

    // Common Actions
    "Submit": "जमा करें", "Save": "सहेजें", "Cancel": "रद्द करें", "Delete": "हटाएँ", "Edit": "संपादित करें",
    "Update": "अपडेट करें", "Create": "बनाएँ", "Search": "खोजें", "Filter": "फ़िल्टर", "Back": "वापस",
    "Close": "बंद करें", "Upload": "अपलोड", "Download": "डाउनलोड", "Add": "जोड़ें", "View": "देखें",
    "Assign": "असाइन करें", "Approve": "स्वीकृत करें", "Reject": "अस्वीकृत करें", "Accept": "स्वीकार करें",
    "Refresh": "रीफ्रेश", "Loading...": "लोड हो रहा है...", "Saving...": "सहेज रहे हैं...",
    "Submitting...": "जमा कर रहे हैं...", "Updating...": "अपडेट कर रहे हैं...",
    "Assigning...": "असाइन कर रहे हैं...", "Rejecting...": "अस्वीकृत कर रहे हैं...",
    "Creating...": "बना रहे हैं...", "Uploading...": "अपलोड कर रहे हैं...",
    "Resubmitting...": "पुनः जमा कर रहे हैं...",

    // Statuses
    "Order Placed": "ऑर्डर दिया गया", "Received by Factory": "फैक्ट्री को प्राप्त",
    "Under Review": "समीक्षा में", "Approved": "स्वीकृत", "Rejected": "अस्वीकृत",
    "Assigned to Supervisor": "सुपरवाइज़र को असाइन", "Scheduled": "निर्धारित",
    "Material Preparation": "सामग्री तैयारी", "In Production": "उत्पादन में",
    "Quality Check": "गुणवत्ता जाँच", "Completed": "पूर्ण", "Dispatched": "प्रेषित",
    "Delivered": "वितरित", "Received": "प्राप्त", "In Review": "समीक्षा में", "Confirmed": "पुष्टि",
    "ORDER PLACED": "ऑर्डर दिया गया", "RECEIVED BY FACTORY": "फैक्ट्री को प्राप्त",
    "UNDER REVIEW": "समीक्षा में", "APPROVED": "स्वीकृत", "REJECTED": "अस्वीकृत",
    "ASSIGNED TO SUPERVISOR": "सुपरवाइज़र को असाइन", "SCHEDULED": "निर्धारित",
    "MATERIAL PREPARATION": "सामग्री तैयारी", "IN PRODUCTION": "उत्पादन में",
    "QUALITY CHECK": "गुणवत्ता जाँच", "COMPLETED": "पूर्ण", "DISPATCHED": "प्रेषित",

    // Priority
    "urgent": "अत्यावश्यक", "high": "उच्च", "normal": "सामान्य", "low": "कम",
    "Urgent": "अत्यावश्यक", "High": "उच्च", "Normal": "सामान्य", "Low": "कम",
    "URGENT": "अत्यावश्यक", "HIGH": "उच्च", "NORMAL": "सामान्य", "LOW": "कम",

    // Factory Dashboard
    "Factory Order Management": "फैक्ट्री ऑर्डर प्रबंधन",
    "Track & manage production orders": "उत्पादन ऑर्डर ट्रैक और प्रबंधित करें",
    "Total Orders": "कुल ऑर्डर", "TOTAL ORDERS": "कुल ऑर्डर",
    "Unassigned": "असाइन नहीं", "UNASSIGNED": "असाइन नहीं",
    "Active Production": "सक्रिय उत्पादन", "ACTIVE PRODUCTION": "सक्रिय उत्पादन",
    "Completed (Month)": "पूर्ण (महीना)", "COMPLETED (MONTH)": "पूर्ण (महीना)",
    "Production Pipeline": "उत्पादन पाइपलाइन",
    "Orders by Priority": "प्राथमिकता अनुसार ऑर्डर",
    "Orders by Department": "विभाग अनुसार ऑर्डर",
    "Kanban": "कानबन", "Table": "तालिका",
    "No orders": "कोई ऑर्डर नहीं", "No orders match filters.": "कोई ऑर्डर फ़िल्टर से मेल नहीं खाता।",
    "No orders yet.": "अभी तक कोई ऑर्डर नहीं।", "No data.": "कोई डेटा नहीं।",
    "Update Status": "स्थिति अपडेट करें", "New Status": "नई स्थिति",
    "Notes (optional)": "नोट्स (वैकल्पिक)", "Notes": "नोट्स",
    "All Priority": "सभी प्राथमिकता", "Search orders...": "ऑर्डर खोजें...",
    "Status": "स्थिति", "Actions": "कार्रवाई",
    "Assign to Supervisor": "सुपरवाइज़र को असाइन करें",
    "Assign this order and optionally schedule production.": "इस ऑर्डर को असाइन करें और वैकल्पिक रूप से उत्पादन शेड्यूल करें।",
    "Supervisor *": "सुपरवाइज़र *", "Select supervisor": "सुपरवाइज़र चुनें",
    "Scheduled Date": "निर्धारित तिथि", "Change the production status.": "उत्पादन स्थिति बदलें।",
    "Reject Order": "ऑर्डर अस्वीकृत करें",
    "Please provide a reason for rejection. This is mandatory.": "कृपया अस्वीकृति का कारण दें। यह अनिवार्य है।",
    "Rejection Reason *": "अस्वीकृति कारण *",
    "Explain why this order is being rejected...": "बताएं कि यह ऑर्डर क्यों अस्वीकृत किया जा रहा है...",
    "Rejection reason is required": "अस्वीकृति कारण आवश्यक है",
    "Reject Order": "ऑर्डर अस्वीकृत करें",
    "Save Settings": "सेटिंग्स सहेजें",
    "Priority Auto-Escalation": "प्राथमिकता ऑटो-एस्केलेशन",

    // Factory Order Detail
    "Order Details": "ऑर्डर विवरण", "Product": "उत्पाद", "PRODUCT": "उत्पाद",
    "Quantity": "मात्रा", "QUANTITY": "मात्रा", "Priority": "प्राथमिकता", "PRIORITY": "प्राथमिकता",
    "Expected Delivery": "अपेक्षित डिलीवरी", "EXPECTED DELIVERY": "अपेक्षित डिलीवरी",
    "Client": "ग्राहक", "CLIENT": "ग्राहक", "Client Ref.": "ग्राहक संदर्भ", "CLIENT REF": "ग्राहक संदर्भ",
    "CLIENT REF.": "ग्राहक संदर्भ",
    "Description": "विवरण", "DESCRIPTION": "विवरण", "Specifications": "विनिर्देश",
    "Assignment & Schedule": "असाइनमेंट और शेड्यूल",
    "Supervisor": "सुपरवाइज़र", "SUPERVISOR": "सुपरवाइज़र",
    "Assigned By": "द्वारा असाइन", "ASSIGNED BY": "द्वारा असाइन",
    "Requested By": "द्वारा अनुरोधित", "REQUESTED BY": "द्वारा अनुरोधित",
    "SCHEDULED DATE": "निर्धारित तिथि",
    "Documents & Attachments": "दस्तावेज़ और अटैचमेंट",
    "Order Timeline": "ऑर्डर टाइमलाइन",
    "Order Timeline / Conversation": "ऑर्डर टाइमलाइन / वार्तालाप",
    "Add a note or update...": "नोट या अपडेट जोड़ें...",
    "Rejection Reason": "अस्वीकृति कारण",
    "Revise & Resubmit": "संशोधित करें और पुनः जमा करें",
    "Not assigned": "असाइन नहीं", "Not scheduled": "निर्धारित नहीं",
    "No documents uploaded yet.": "अभी तक कोई दस्तावेज़ अपलोड नहीं।",
    "Preview not available for this file type.": "इस फ़ाइल प्रकार के लिए पूर्वावलोकन उपलब्ध नहीं।",
    "Select status": "स्थिति चुनें",

    // My Factory Orders
    "Submit and track production orders": "उत्पादन ऑर्डर जमा करें और ट्रैक करें",
    "New Order": "नया ऑर्डर", "Pending": "लंबित",
    "Submit Factory Order": "फैक्ट्री ऑर्डर जमा करें",
    "Create a new production order for the factory team.": "फैक्ट्री टीम के लिए नया उत्पादन ऑर्डर बनाएँ।",
    "Product / Item *": "उत्पाद / आइटम *", "Product / Item": "उत्पाद / आइटम",
    "Expected Delivery Date": "अपेक्षित डिलीवरी तिथि",
    "Client Name (optional)": "ग्राहक नाम (वैकल्पिक)", "Client Name": "ग्राहक नाम",
    "Client Reference": "ग्राहक संदर्भ",
    "Attachments (Images, Drawings, PDFs)": "अटैचमेंट (चित्र, ड्रॉइंग, PDF)",
    "Submit Order": "ऑर्डर जमा करें", "No factory orders yet. Create your first order.": "अभी तक कोई फैक्ट्री ऑर्डर नहीं। अपना पहला ऑर्डर बनाएं।",
    "No orders with this status.": "इस स्थिति में कोई ऑर्डर नहीं।",
    "Add Files": "फ़ाइलें जोड़ें",
    "Click to add product images, drawings, or documents": "उत्पाद चित्र, ड्रॉइंग या दस्तावेज़ जोड़ने के लिए क्लिक करें",

    // Infrastructure
    "Infrastructure Department": "इन्फ्रा विभाग", "Infrastructure Clients": "इन्फ्रा ग्राहक",
    "Order tracking & client management": "ऑर्डर ट्रैकिंग और ग्राहक प्रबंधन",
    "Total Clients": "कुल ग्राहक", "Revenue": "राजस्व", "Pending Drawings": "लंबित ड्रॉइंग",
    "View Clients": "ग्राहक देखें", "Add Client": "ग्राहक जोड़ें", "Send to Factory": "फैक्ट्री भेजें",
    "Orders by Status": "स्थिति अनुसार ऑर्डर", "Orders by Source": "स्रोत अनुसार ऑर्डर",
    "Order Pipeline": "ऑर्डर पाइपलाइन",

    // Leads page
    "584 leads total": "कुल 584 लीड्स", "All Time": "सभी समय", "Today": "आज",
    "Yesterday": "कल", "This Week": "इस सप्ताह", "Last Week": "पिछला सप्ताह",
    "This Month": "इस महीने", "Last Month": "पिछला महीना", "Last Quarter": "पिछली तिमाही",
    "Last 6 Months": "पिछले 6 महीने", "Last Year": "पिछला वर्ष", "Custom Date": "कस्टम तिथि",
    "Search by name, phone, email...": "नाम, फ़ोन, ईमेल से खोजें...",
    "All Statuses": "सभी स्थितियाँ", "All Sources": "सभी स्रोत",
    "NAME": "नाम", "CONTACT": "संपर्क", "SOURCE": "स्रोत", "STATUS": "स्थिति",
    "SCORE": "स्कोर", "ASSIGNED TO": "असाइन", "ACTIONS": "कार्रवाई",
    "Export CSV": "CSV निर्यात", "Upload Sheet": "शीट अपलोड", "Add Lead": "लीड जोड़ें",

    // Common labels
    "Order": "ऑर्डर", "orders": "ऑर्डर", "files": "फ़ाइलें",
    "Translate": "अनुवाद", "Hide": "छुपाएँ",
    "Show original": "मूल दिखाएँ", "Show translated": "अनुवाद दिखाएँ", "Auto-translated": "स्वत: अनुवादित", "You": "आप",
    "Channels": "चैनल", "Direct Messages": "सीधे संदेश",
    "Search people...": "लोग खोजें...", "Message": "संदेश",
    "Daily Schedule": "दैनिक कार्यक्रम",
    "Scheduled Today": "आज निर्धारित",
    "Scheduled Tomorrow": "कल निर्धारित",
    "Overdue": "समयातीत",
    "This Week (next 7 days)": "इस सप्ताह (अगले 7 दिन)",
    "Upcoming Deadlines": "आगामी समय-सीमाएँ",
    "No orders scheduled for today.": "आज के लिए कोई ऑर्डर निर्धारित नहीं है।",
    "Nothing on the books for tomorrow.": "कल के लिए कुछ भी निर्धारित नहीं है।",
    "All orders on track — no overdue items.": "सभी ऑर्डर समय पर हैं — कोई विलंबित आइटम नहीं।",
    "No production scheduled for the rest of the week.": "सप्ताह के शेष दिनों के लिए कोई उत्पादन निर्धारित नहीं।",
    "No delivery deadlines in the next 7 days.": "अगले 7 दिनों में कोई डिलीवरी समय-सीमा नहीं।",
    "just now": "अभी", "Updated": "अपडेटेड",
    "Manager: You can set any stage.": "प्रबंधक: आप कोई भी स्थिति सेट कर सकते हैं।",
    "Supervisor: You can update production stages.": "सुपरवाइज़र: आप उत्पादन स्थिति अपडेट कर सकते हैं।",
    "Move": "स्थानांतरित", "to the next stage.": "अगली स्थिति में।",
    "No data": "कोई डेटा नहीं",
    "Update notes...": "अपडेट नोट्स...",
  }
};

export function LanguageProvider({ children }) {
  const { user, api } = useAuth();
  // Initialize from localStorage first (instant), then sync with user preference
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("ameenji_lang");
    return stored || user?.language || "en";
  });

  // Sync language from user profile on login
  useEffect(() => {
    if (user?.language && user.language !== lang) {
      setLang(user.language);
      localStorage.setItem("ameenji_lang", user.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);

  const t = useCallback((text) => {
    if (lang === "en" || !text) return text;
    return TRANSLATIONS[lang]?.[text] || text;
  }, [lang]);

  const switchLanguage = useCallback(async (newLang) => {
    setLang(newLang);
    localStorage.setItem("ameenji_lang", newLang);
    try {
      const fd = new FormData();
      fd.append("language", newLang);
      await api.put("/language/preference", fd);
    } catch (err) {
      console.error("Failed to save language:", err);
    }
  }, [api]);

  const translateText = useCallback(async (text, targetLang) => {
    if (!text?.trim()) return text;
    const target = targetLang || (lang === "en" ? "hi" : "en");
    try {
      const fd = new FormData();
      fd.append("text", text);
      fd.append("target_lang", target);
      const res = await api.post("/language/translate", fd);
      return res.data.translated;
    } catch {
      return text;
    }
  }, [api, lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, switchLanguage, translateText }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "en", t: (x) => x, switchLanguage: () => {}, translateText: async (x) => x };
  return ctx;
}
